export default __webpack_public_path__ + "static/media/meetnow.8d63820e.svg";